import { ref } from "vue";

export const now = ref<Date>(new Date())

const update = () => {
    now.value = new Date()
    setTimeout(update, 250)
}

update()